export default __webpack_public_path__ + "static/media/jangkau_pelanggan.79ad5f3e.svg";